/**
 * @prop --stzh-flyingfocus-color: **Global**: Accent color of flying focus
 */

.stzh-flyingfocus {
  border: 0 solid currentColor;
  position: absolute;
  transform: translate(-50%, -50%);
  opacity: 0;
  will-change: top, left, width, height;
  box-sizing: content-box;
  pointer-events: none;
  overflow: hidden;
  z-index: 9999999999;

  @media print {
    display: none;
  }

  &--is-moving {
    transition-property:
      opacity, left, top, width, height, border-width, border-radius;
    transition-duration: 0.2s, 0.1s, 0.1s, 0.1s, 0.1s, 0.1s, 0.1s;
    transition-timing-function: linear, ease, ease, ease, ease, ease, ease;

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }

  &--is-enabled#{&}--is-visible {
    opacity: 1;
  }

  &::after {
    content: "";
    background: currentColor;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.2s linear;

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }

  &--has-helper::after {
    transition-duration: 0.1s;
    opacity: 0.16;
  }
}
